import { IonCard, IonText } from '@ionic/react';
import { PropsWithChildren } from 'react';

import { Icon, IconName } from '@/components/Icon';
import { IconRotate } from '@/components/Icon/types';
import styles from '@/components/QuickLinkCard/index.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

interface SharedQuickLinkCardProps {
  icon: IconName;
  color: 'green' | 'yellow' | 'teal';
  showOn: 'production' | 'development';
}

interface RouterLink extends SharedQuickLinkCardProps {
  routerLink: string;
  routerDirection: 'forward';
  onClick?: never;
}

interface Button extends SharedQuickLinkCardProps {
  onClick: () => void;
  routerLink?: never;
  routerDirection?: never;
}

export type QuickLinkCardProps = RouterLink | Button;

export const QuickLinkCard = ({
  icon,
  children,
  color,
  onClick,
  routerDirection,
  routerLink,
}: PropsWithChildren<QuickLinkCardProps>) => {
  return (
    <IonCard
      {...(typeof routerLink === 'string' ? { routerLink, routerDirection } : { onClick, button: true })}
      className={mergeClassNames(styles.card, 'ion-activated', onClick && styles.button)}>
      <div className={mergeClassNames(styles.color, styles[color])}>
        <Icon className={styles.icon} name={icon} />
      </div>

      <IonText className={styles.text}>{children}</IonText>

      <Icon className={styles.icon} color='#829696' direction={IconRotate.East} name='chevron' size={14} />
    </IonCard>
  );
};
